module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-support-register/master-support-register.component.scss
// module id = ./src/app/master/master-support-register/master-support-register.component.scss
// module chunks = main